import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock, X } from "lucide-react";
import api from "../lib/api";

/** Site-wide vacation / temporary-closure notice, controlled from the dashboard. */
export default function ClosureNotice() {
  const [closure, setClosure] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api
      .get("/site/config")
      .then(({ data }) => {
        if (data?.closure?.active) setClosure(data.closure);
      })
      .catch(() => setClosure(null));
  }, []);

  if (!closure || dismissed) return null;

  return (
    <div className="bg-[#a10000] text-white" role="status">
      <div className="mr-container-wide flex items-start gap-3 py-3">
        <CalendarClock className="mt-0.5 h-5 w-5 shrink-0" />
        <div className="flex-1 text-[14px] leading-relaxed">
          {closure.title && <strong className="mr-2">{closure.title}</strong>}
          <span>{closure.message}</span>
          {closure.until && (
            <span className="ml-2 opacity-90">
              (until {new Date(closure.until).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })})
            </span>
          )}
          <Link to="/contact-us" className="ml-2 underline">
            Send a message anyway
          </Link>
        </div>
        <button onClick={() => setDismissed(true)} aria-label="Dismiss notice" className="shrink-0">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
